export const scrollToDOMElement = (querySelector: string, options?: ScrollIntoViewOptions) => {
    const element = document.querySelector(querySelector);

    element && element.scrollIntoView({ behavior: 'smooth', ...options });
};
